module.exports = __webpack_public_path__ + "img/audio.7cf57cfb.svg";